'use strict';

import React, { Component } from 'react';
import { ListItem, ListItemText, ListItemIcon, Typography, Button, TableBody, TableRow, TableCell, Box } from '@material-ui/core';
import { Close, List, Create, ListRounded } from '@material-ui/icons';
import { TableLayout } from '../Stock/containers/Layout';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import Dialog from '../../../commonModules/interface/Dialog.jsx';

var $ = require('jquery');

class ProfileBoxItemBoxStatus extends Component{
    state = {
            //Initiate Time for the chart
            BoxInfoStatus: 'pmb-block',
            MenuBoxInfoStatus: 'dropdown',

            totalProd: '',
            batVoltage: '',
            lastconsoDay: ''
        }
    componentDidMount() {
        var methodName = 'Get User Prod';
        var urlBoxFreeOfAssociation = "/production/resume?boxAssoId=" + this.props.boxAssoId;

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            var totalProd= '';
            var batVoltage= '';
            var lastconsoDay= '';
            try {
                var data = result; //var data = JSON.parse(result);
                totalProd= data.totalProd ;
                batVoltage= data.batVoltage ;
                lastconsoDay= data.lastconsoDay ;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
              totalProd: totalProd,
              batVoltage: batVoltage,
              lastconsoDay: lastconsoDay,
            });
        }.bind(this));
    }
    render() {

        return (
            this.state.totalProd !== "err" ?
            <MiniCard 
                title="System Information"
                avatar={<ListRounded />}
            >
                
                {this.state.openNewEquip &&
                    <Dialog 
                        block={true}
                        title="Ajouter un equipement"
                        text={"formEquip"}
                        close={() => {
                            this.setState({ openNewEquip: false })
                        }}
                    />
                }
                <Box>
                    <TableLayout>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th">Total Production</TableCell>
                                <TableCell>{this.state.totalProd}
                                    &nbsp;kWh</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Last Batterie Voltage</TableCell>
                                <TableCell>{this.state.batVoltage}
                                    &nbsp;V</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Last Consumption Day</TableCell>
                                <TableCell>{this.state.lastconsoDay}
                                    &nbsp;Wh</TableCell>
                            </TableRow>
                        </TableBody>
                    </TableLayout> 
                </Box>
            </MiniCard>
            : ""
            // <div>
            //     {this.state.totalProd !== "err" &&
            //         <div>
            //             <ListItem button>
            //                 <ListItemIcon>
            //                     <List />
            //                 </ListItemIcon>
            //                 <ListItemText><Typography variant="h4">System Information</Typography></ListItemText>
            //             </ListItem>
                            
            //             <div className="pmbb-body p-l-30">
            //                 <div className="pmbb-view">
            //                     <dl className="dl-horizontal">
            //                         <dt>Total Production</dt>
            //                         <dd>{this.state.totalProd}
            //                             &nbsp;kWh</dd>
            //                     </dl>
            //                     <dl className="dl-horizontal">
            //                         <dt>Last Batterie Voltage</dt>
            //                         <dd>{this.state.batVoltage}
            //                             &nbsp;V</dd>
            //                     </dl>
            //                     <dl className="dl-horizontal">
            //                         <dt>Last Consumption Day</dt>
            //                         <dd>{this.state.lastconsoDay}
            //                             &nbsp;Wh</dd>
            //                     </dl>
            //                 </div>
            //             </div>
            //         </div>
            //     }
            // </div>

        )
    }
};
export default ProfileBoxItemBoxStatus
